import { Input, Output, EventEmitter, Directive } from '@angular/core';
import { FormFieldModel } from '../../models/form-field.model';
import { BlockModel } from '../../models/block.model';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class AbstractFormFieldComponent {
    @Input() field: FormFieldModel;
    @Input() value: any;
    @Input() block: BlockModel = null;
    @Output() changes: EventEmitter<any> = new EventEmitter<any>();

    @Input() public id: string;
}
